<template>
    <div class="row h-100">
        <div
            class="col-12 algolia-listing-product-block__product-sale-pricing-wrapper pr-0"
        >
            <div
                class="algolia-listing-product-block__product-sale-price-per-kg"
                v-text="combination.price_punit_for ? combination.price_punit_for.replace(/[()]/g , '') : combination.price_pkilo_for.replace(/[()]/g , '')"
            >
            </div>
            <div class="algolia-listing-product-block__product-price" itemprop="price">
                {{ combination.price_for_display }}
            </div>
            <div class="algolia-listing-product-block__product-sale-price-subnote">{{ $t('myAccount.bundleDiscount')}}: {{ combination.bundle_discount_formatted }}</div>
        </div>
        <meta itemprop="availability" href="https://schema.org/InStock" />
    </div>
</template>

<script>
export default {
    name: "PricingDiscount",
    props: {
        combination: {
            type: Object,
            required: true
        }
    }
};
</script>
